import {throwError as observableThrowError} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class MainMenuService {
    constructor(private http: HttpClient) {
    }

    public getData(userid: Object) {
        let URL = 'assets/data/main-menu.json';
        if (userid["custom:access"] === 'SU'|| userid["custom:access"] === 'GA') {
           URL = 'assets/data/admin-main-menu.json';
        }
        else if(userid["custom:access"] === 'QA'){
         URL = 'assets/data/QA-menu.json';
        }
        else
        {
         URL = 'assets/data/main-menu.json';
        }
        return this.http.get(URL);
    }

    public handleError(error: any) {
        return observableThrowError(error.error || 'Server Error');
    }
}
